import { Controller } from "@hotwired/stimulus"
import { stimulus } from "../init"

export default class CartDrawer extends Controller {
  static targets = ["drawer", "overlay"]

  open() {
    console.log("drawer", this.overlayTarget)

    this.overlayTarget.classList.add("open")
    this.drawerTarget.classList.add("open")
    document.body.style.overflow = "hidden"
  }

  close() {
    this.drawerTarget.classList.remove("open")
    this.overlayTarget.classList.remove("open")
    document.body.style.overflow = ""
  }

  // Close on Escape key
  keydown(event) {
    if (event.key === "Escape") this.close()
  }

    connect() {
        // console.log(this.hasOverlayTarget)
        // // console.log(this.hasDrawerTarget)
        // console.log(this.element)                    // ← what element has data-controller="cartdrawer"?
        // console.log(this.overlayTarget)              // ← should log the <div id="cartdrawer-overlay">
        // console.log(this.hasOverlayTarget)           // ← false → big clue
        // console.log(this.element.querySelector("[data-cartdrawer-target='overlay']"))

        this._keydown = this.keydown.bind(this)
        document.addEventListener("keydown", this._keydown)
    }

  disconnect() {
    document.removeEventListener("keydown", this._keydown)
  }
}

stimulus.register('cartdrawer', CartDrawer)
